
import { Vue, Component, Prop } from "vue-property-decorator";
import { ModelLinkSummaryResource, LinkRecord } from "@/models/api/barcodeSystem/inventory/modelLinkSummary";


@Component
export default class ModelLinkSummary extends Vue {
  @Prop({default: null})
  modelLinkSummaryResource: ModelLinkSummaryResource;

  get companyName(): string {
    return this.modelLinkSummaryResource && this.modelLinkSummaryResource.company
      ? this.modelLinkSummaryResource.company.companyName
      : null; 
  }

  set companyName(val: string){
  }

  get manufacturerCode(): string {
    return this.modelLinkSummaryResource && this.modelLinkSummaryResource.manufacturer
      ? this.modelLinkSummaryResource.manufacturer.code
      : null; 
  }

  set manufacturerCode(val: string){
  }


  get poNumber(): string {
    return this.modelLinkSummaryResource
      ? this.modelLinkSummaryResource.poNumber
      : null; 
  }

  set poNumber(val: string){
  }

  get modelNumber(): string {
    return this.modelLinkSummaryResource
      ? this.modelLinkSummaryResource.modelNumber
      : null; 
  }

  set modelNumber(val: string){
  }  
  
  get totalQuantity(): number {
    return this.modelLinkSummaryResource
      ? this.modelLinkSummaryResource.totalQuantity
      : 0; 
  }

  set totalQuantity(val: number){
  }

  get linkRecords(): Array<LinkRecord> {
    return this.modelLinkSummaryResource
      ? this.modelLinkSummaryResource.linkRecords
      : null; 
  }

  set linkRecords(val: Array<LinkRecord>){
  }
}
